export interface DropdownDependency {
  fieldKey: string;
  displayKey: string;
  displayLabel: string;
  loadApiSlug: string;
  loadDataKey: string;
}

export interface MasterConfig {
  masterType: string;
  routeSlug: string;
  apiSlug: string;
  dataKey: string;
  singularDataKey?: string;
  dropdownDeps?: DropdownDependency[];
  displayNameField?: string;
  module?: string;
}

export const MASTER_CONFIGS: Record<string, MasterConfig> = {
  'terms': {
    masterType: 'terms', routeSlug: 'terms',
    apiSlug: 'terms', dataKey: 'terms', singularDataKey: 'term',
  },
  'vendor-type': {
    masterType: 'vendor_type', routeSlug: 'vendor-type',
    apiSlug: 'vendor-types', dataKey: 'vendor_types', singularDataKey: 'vendor_type',
  },
  'vendor-group': {
    masterType: 'vendor_group', routeSlug: 'vendor-group',
    apiSlug: 'vendor-groups', dataKey: 'vendor_groups', singularDataKey: 'vendor_group',
  },
  'category': {
    masterType: 'category', routeSlug: 'category',
    apiSlug: 'vendor-categories', dataKey: 'vendor_categories', singularDataKey: 'vendor_category',
  },
  'nature-of-document': {
    masterType: 'nature_of_document', routeSlug: 'nature-of-document',
    apiSlug: 'nature-of-documents', dataKey: 'nature_of_documents', singularDataKey: 'nature_of_document',
    displayNameField: 'nature_name',
  },
  'tds-section': {
    masterType: 'tds_section', routeSlug: 'tds-section',
    apiSlug: 'tds-sections', dataKey: 'tds_sections', singularDataKey: 'tds_section',
    displayNameField: 'tds_section',
    dropdownDeps: [{
      fieldKey: 'vendor_type_id',
      displayKey: 'vendor_type_name',
      displayLabel: 'Vendor Type',
      loadApiSlug: 'vendor-types',
      loadDataKey: 'vendor_types',
    }],
  },
  'tcs-section': {
    masterType: 'tcs_section', routeSlug: 'tcs-section',
    apiSlug: 'tcs-sections', dataKey: 'tcs_sections', singularDataKey: 'tcs_section',
    displayNameField: 'tcs_section',
  },
  'reason-for-return': {
    masterType: 'reason_for_return', routeSlug: 'reason-for-return',
    apiSlug: 'reason-for-returns', dataKey: 'reason_for_returns', singularDataKey: 'reason_for_return',
  },
  'reason-for-credit-note': {
    masterType: 'reason_for_credit_note', routeSlug: 'reason-for-credit-note',
    apiSlug: 'reason-for-credit-notes', dataKey: 'reason_for_credit_notes', singularDataKey: 'reason_for_credit_note',
  },
  'shipping-method': {
    masterType: 'shipping_method', routeSlug: 'shipping-method',
    apiSlug: 'shipping-methods', dataKey: 'shipping_methods', singularDataKey: 'shipping_method',
  },
  'refund-method': {
    masterType: 'refund_method', routeSlug: 'refund-method',
    apiSlug: 'refund-methods', dataKey: 'refund_methods', singularDataKey: 'refund_method',
  },
  'bank-name': {
    masterType: 'bank_name', routeSlug: 'bank-name',
    apiSlug: 'bank-names', dataKey: 'bank_names', singularDataKey: 'bank_name',
  },
  'bank-details': {
    masterType: 'bank_details', routeSlug: 'bank-details',
    apiSlug: 'bank-details', dataKey: 'bank_details', singularDataKey: 'bank_detail',
  },
  'client-category': {
    masterType: 'client_category', routeSlug: 'client-category',
    apiSlug: 'client-categories', dataKey: 'client_categories', singularDataKey: 'client_category',
  },
  'client-group': {
    masterType: 'client_group', routeSlug: 'client-group',
    apiSlug: 'client-groups', dataKey: 'client_groups', singularDataKey: 'client_group',
  },
  'contact-role': {
    masterType: 'contact_role', routeSlug: 'contact-role',
    apiSlug: 'contact-roles', dataKey: 'contact_roles', singularDataKey: 'contact_role',
  },
  'line-of-business': {
    masterType: 'line_of_business', routeSlug: 'line-of-business',
    apiSlug: 'line-of-businesses', dataKey: 'line_of_businesses', singularDataKey: 'line_of_business',
  },
  'sales-type': {
    masterType: 'sales_type', routeSlug: 'sales-type',
    apiSlug: 'sales-types', dataKey: 'sales_types', singularDataKey: 'sales_type',
  },
  'shipping-carrier': {
    masterType: 'shipping_carrier', routeSlug: 'shipping-carrier',
    apiSlug: 'shipping-carriers', dataKey: 'shipping_carriers', singularDataKey: 'shipping_carrier',
  },
  'manufacturer': {
    masterType: 'manufacturer', routeSlug: 'manufacturer',
    apiSlug: 'manufacturer-masters', dataKey: 'manufacturer_masters', singularDataKey: 'manufacturer_master',
  },
  'item-unit': {
    masterType: 'packaging', routeSlug: 'item-unit',
    apiSlug: 'packaging-masters', dataKey: 'packaging_masters', singularDataKey: 'packaging_master',
  },
  'item-type': {
    masterType: 'item_type', routeSlug: 'item-type',
    apiSlug: 'type-masters', dataKey: 'type_masters', singularDataKey: 'type_master',
  },
  'nature-of-goods': {
    masterType: 'nature_of_goods', routeSlug: 'nature-of-goods',
    apiSlug: 'nature-of-goods', dataKey: 'nature_of_goods', singularDataKey: 'nature_of_goods',
  },
  'cost-category': {
    masterType: 'cost_category', routeSlug: 'cost-category',
    apiSlug: 'cost-categories', dataKey: 'cost_categories', singularDataKey: 'cost_category',
  },
  'expiry-category': {
    masterType: 'expiry_category', routeSlug: 'expiry-category',
    apiSlug: 'expiry-categories', dataKey: 'expiry_categories', singularDataKey: 'expiry_category',
  },
  'storage-option': {
    masterType: 'storage', routeSlug: 'storage-option',
    apiSlug: 'storages', dataKey: 'storages', singularDataKey: 'storage',
  },
  'file-type': {
    masterType: 'file_type', routeSlug: 'file-type',
    apiSlug: 'file-types', dataKey: 'file_types', singularDataKey: 'file_type',
  },
  'bmw-departments': {
    masterType: 'bmw_department', routeSlug: 'bmw-departments',
    apiSlug: 'departments', dataKey: 'departments', singularDataKey: 'department',
    module: 'bmw',
  },
  'bmw-ward-rooms': {
    masterType: 'bmw_ward_room', routeSlug: 'bmw-ward-rooms',
    apiSlug: 'ward-rooms', dataKey: 'ward_rooms', singularDataKey: 'ward_room',
    module: 'bmw',
    dropdownDeps: [{
      fieldKey: 'department_id',
      displayKey: 'department_name',
      displayLabel: 'Department',
      loadApiSlug: 'departments',
      loadDataKey: 'departments',
    }],
  },
  'bmw-waste-categories': {
    masterType: 'bmw_waste_category', routeSlug: 'bmw-waste-categories',
    apiSlug: 'waste-categories', dataKey: 'waste_categories', singularDataKey: 'waste_category',
    module: 'bmw',
  },
  'bmw-containers': {
    masterType: 'bmw_container', routeSlug: 'bmw-containers',
    apiSlug: 'containers', dataKey: 'containers', singularDataKey: 'container',
    module: 'bmw',
    displayNameField: 'container_code',
    dropdownDeps: [{
      fieldKey: 'waste_category',
      displayKey: 'waste_category',
      displayLabel: 'Waste Category',
      loadApiSlug: 'waste-categories',
      loadDataKey: 'waste_categories',
    }],
  },
  'bmw-responsibilities': {
    masterType: 'bmw_responsibility', routeSlug: 'bmw-responsibilities',
    apiSlug: 'responsibilities', dataKey: 'responsibilities', singularDataKey: 'responsibility',
    module: 'bmw',
    dropdownDeps: [{
      fieldKey: 'module_id',
      displayKey: 'module_name',
      displayLabel: 'Module',
      loadApiSlug: 'modules',
      loadDataKey: 'modules',
    }],
  },
};
